import styles from "./Faq.module.css";
import Reveal from "./Reveal";
import Icon from "./Icons";
import { faqs } from "../data/content";
import useSiteSettings from "../hooks/useSiteSettings";

/* Slugs give every answer its own anchor, so a question can be linked
   directly and Google can deep-link it from a rich result. */
const slug = (q) =>
  q.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "").slice(0, 60);

export default function Faq() {
  const { doctor } = useSiteSettings();
  return (
    <section className={`u-section ${styles.section}`}>
      <div className="u-shell">
        <ul className={styles.list}>
          {faqs.map((item, i) => (
            <Reveal as="li" key={item.q} delay={Math.min(i, 5) * 60}>
              {/* native <details>: content stays in the DOM and stays
                  crawlable, and keyboard behaviour is free */}
              <details className={styles.item} id={slug(item.q)} open={i === 0}>
                <summary className={styles.summary}>
                  <h2 className={styles.q}>{item.q}</h2>
                  <span className={styles.chevron} aria-hidden="true">
                    <Icon name="plus" size={18} />
                  </span>
                </summary>
                <div className={styles.answer}>
                  <p>{item.a}</p>
                </div>
              </details>
            </Reveal>
          ))}
        </ul>

        <p className={styles.tail}>
          Still unsure whether physiotherapy is the right call?{" "}
          <a href={`https://wa.me/${doctor.whatsapp}`} target="_blank" rel="noopener noreferrer">
            Ask me on WhatsApp
          </a>{" "}
          — I would rather tell you honestly than book a session you do not need.
        </p>
      </div>
    </section>
  );
}
